export const initialState = {
  loading: false,
  error: null,
  categorySelected: null,
  category: null,
  categories: [],
  response: { message: null, error: null },
  currentCategoryId: 0,
};
